import Footer from '@/components/Footer';
import { SellerContext } from '@/context/SellerContext';
import axios from 'axios';
import { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
var cookie = require('cookie');

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const cookies = cookie.parse(req.headers.cookie || '');
  const token = cookies['popin-seller'] || null;
  if (token) {
    return {
      redirect: {
        destination: '/agent',
        permanent: false,
      },
    };
  }
  return {
    props: {
      token,
    },
  };
};

const Login: NextPage = () => {
  const router = useRouter();

  const [email, setEmail] = useState('');
  const [otp, setOTP] = useState('');
  const [loadingForm, setLoadingForm] = useState(false);
  const [formStep, setFormStep] = useState(1);
  const [loginError, setLoginError] = useState('');

  const { sellerData, setSellerData } = useContext(SellerContext);

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
  };

  const handleOTPChange = (e: any) => {
    setOTP(e.target.value);
  };

  useEffect(() => {
    const token = localStorage.getItem('popin-seller');
    if (token) {
      document.cookie = `popin-seller=${token}; path=/`;
      router.push(`/agent`);
    }
  });

  const onCodeSubmit = () => {
    setLoadingForm(true);
    axios
      .post(process.env.NEXT_PUBLIC_API_URL + '/api/v1/seller/validate/otp', {
        email: email,
        otp: otp,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setSellerData({
            ...sellerData,
            token: res.data.token,
            id: res.data.id,
            name: res.data.name,
            uid: res.data.uid,
            channel: res.data.channel,
            agent: res.data.chanel,
          });
          document.cookie = `popin-seller=${res.data.token}; path=/`;
          localStorage.setItem('popin-seller', res.data.token);
          localStorage.setItem(
            'lk-user-choices',
            JSON.stringify({
              username: res.data.name,
            }),
          );
          router.push(`/agent`);
        } else {
          setLoginError(res.data.message);
        }
        setLoadingForm(false);
      });
  };

  const onEmailSubmit = () => {
    if (validateEmail() == false) {
      setLoginError('Please Enter a Valid Email Address');
      return;
    }
    setLoadingForm(true);
    axios
      .post(process.env.NEXT_PUBLIC_API_URL + '/api/v1/seller/login', {
        email: email,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setFormStep(2);
          setLoginError('');
        } else {
          setLoginError(res.data.message);
        }
        setLoadingForm(false);
      });
  };

  function validateEmail() {
    if (email.length > 0) {
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let valid = re.test(email);
      if (valid) {
        return true;
      }
    }
    return false;
  }

  return (
    <>
      <Head>
        <title>Popin Agent Login</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <main data-lk-theme="default" className="main">
        <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}>
          <div className="header" style={{ width: '100%', maxWidth: '448px', padding: '0 8px' }}>
            <h1 style={{ marginBottom: '10px', textAlign: 'left' }}></h1>

            <div className="form">
              {formStep == 1 ? (
                <>
                  <label style={{ marginTop: '20px', textAlign: 'left' }}>Email</label>
                  <input
                    className="form-control"
                    onChange={handleEmailChange}
                    value={email}
                    placeholder="Enter Email"
                    disabled={loadingForm}
                  />
                  <span style={{ color: 'red' }}>{loginError}</span>
                  <button className="form-button" onClick={onEmailSubmit} disabled={loadingForm}>
                    Get OTP
                  </button>
                </>
              ) : (
                <>
                  <label style={{ marginTop: '20px', textAlign: 'left' }}>OTP</label>
                  <input
                    className="form-control"
                    onChange={handleOTPChange}
                    value={otp}
                    placeholder="Enter OTP"
                    disabled={loadingForm}
                  />
                  <span style={{ color: 'red' }}>{loginError}</span>
                  <button className="form-button" onClick={onCodeSubmit} disabled={loadingForm}>
                    Login
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Login;
